import React from "react";
import { createSlice } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";

const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const onboardingEditAddress: any = createSlice({
  name: "onboardingEditAddress",
  initialState: {
    data: [],
    isCompleted: false,
    isLoading: false,
  },
  reducers: {
    raise_api_call_edit_address: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_edit_address: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failure_api_call_edit_address: (state, action) => {
      state.isLoading = false;
      FAILED(action.payload);
    },
  },
});
export default onboardingEditAddress.reducer;
export const {
  raise_api_call_edit_address,
  success_api_call_edit_address,
  failure_api_call_edit_address,
} = onboardingEditAddress.actions;
